import { Button, FieldMessage, Label, Select, Text, TextInput } from '@elladx/design-system';
import { Search } from 'lucide-react';
import type { DateFilters } from '../../types';
import type { OrderDatePreset } from '../../utils/orderFilters';
interface OrderFilterBarProps {
    filters: DateFilters;
    count: number;
    datePreset: OrderDatePreset;
    dateError?: string;
    onDatePresetChange: (preset: OrderDatePreset) => void;
    onFilterChange: (field: keyof DateFilters, value: string) => void;
    onClearFilters: () => void;
}
function OrderFilterBar({ filters, count, datePreset, dateError, onDatePresetChange, onFilterChange, onClearFilters }: OrderFilterBarProps) {
    return (<div className="card-toolbar management-filters">
      <div className="management-field management-search">
        <Label htmlFor="order-search">Search recipients or tracking numbers</Label>
        <div className="field-search">
          <Search size={16} aria-hidden="true"/>
          <TextInput id="order-search" type="search" placeholder="Name or tracking number" value={filters.search || ''} onChange={(e) => onFilterChange('search', e.target.value)}/>
        </div>
      </div>
      <div className="management-field">
        <Label htmlFor="order-date-preset">Date range</Label>
        <Select id="order-date-preset" value={datePreset} onChange={e => onDatePresetChange(e.target.value as OrderDatePreset)}>
          <option value="all">All time</option><option value="today">Today</option><option value="7days">Last 7 days</option><option value="30days">Last 30 days</option><option value="custom">Custom dates</option>
        </Select>
      </div>
      <div className="management-field">
        <Label htmlFor="order-status-filter">Status</Label>
        <Select id="order-status-filter" value={filters.status || 'all'} onChange={e => onFilterChange('status', e.target.value)}>
          <option value="all">All</option><option value="needs_attention">Needs attention</option><option value="in_transit">In transit</option><option value="delivered">Delivered</option><option value="refunds">Refunds</option>
        </Select>
      </div>
      {datePreset === 'custom' && <div className="management-date-fields">
        <div className="management-field"><Label htmlFor="order-start-date">Start date</Label><TextInput id="order-start-date" type="date" max={filters.endDate} value={filters.startDate || ''} onChange={e => onFilterChange('startDate', e.target.value)} aria-describedby={dateError ? 'order-date-error' : undefined}/></div>
        <div className="management-field"><Label htmlFor="order-end-date">End date</Label><TextInput id="order-end-date" type="date" min={filters.startDate} value={filters.endDate || ''} onChange={e => onFilterChange('endDate', e.target.value)} aria-describedby={dateError ? 'order-date-error' : undefined}/></div>
      </div>}
      {dateError && <FieldMessage id="order-date-error" error role="alert">{dateError}</FieldMessage>}
      <div className="management-filter-footer"><Text size="small" tone="muted">{count} shown · Dates use {Intl.DateTimeFormat().resolvedOptions().timeZone || 'your local timezone'}.</Text><Button type="button" onClick={onClearFilters} variant="ghost" size="sm">Clear filters</Button></div>
    </div>);
}
export default OrderFilterBar;
